import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';

@observer export default class Checkbox extends React.Component {
  static propTypes = {
    title: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    value: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number
    ]),
    onChange: PropTypes.func,

    disabled: PropTypes.bool,
    labelIsSrOnly: PropTypes.bool,
    checked: PropTypes.bool,
    required: PropTypes.bool,
    errorMessage: PropTypes.string,
    announceError: PropTypes.bool
  }

  static defaultProps = {
    title: '',
    value: '',
    checked: false, //Note: checked must always have a value so this can be a controlled component
    disabled: false,
    errorMessage: ''
  }

  constructor(props) {
    super(props);
    this.ENTER_KEY_CODE = 13;
  }

  onChange = (event) => {
    if(this.props.disabled) {
      event.preventDefault();
    } else {
      if (this.props.onChange) {
        this.props.onChange(event.target);
      }
    }
  }

  onKeyPress = (event) => {
    if(event.charCode === this.ENTER_KEY_CODE) {
      this.onChange(event);
    }
  }

  render() {
    const disabledClass = this.props.disabled
      ? 'disabled'
      : '';
    return (
      <div className={`checkbox form-group ${disabledClass}`}>
        {this.hasVisibleError &&
          <div className="msgBlock error error-list" role={this.props.announceError ? 'status' : ''} aria-live={this.props.announceError ? 'polite' : ''}>
            <span>{this.props.errorMessage}</span>
          </div>
        }
        <label className="checkbox-label">
          <input
            type="checkbox"
            id={this.props.title}
            ref={(i) => { this.input = i; }}
            aria-disabled={this.props.disabled}
            value={this.props.value}
            checked={this.props.checked}
            data-checked={this.props.checked/*custom DOM prop included for automated testing*/}
            onChange={this.onChange}
            onKeyPress={this.onKeyPress}
            onBlur={this.onBlur}/>
          <span className="cr"></span>
          <span className={`label-text ${this.props.labelIsSrOnly ? 'sr-only' : ''}`}>
            {this.props.title || this.props.value}
            {this.props.required &&
              <span className="required-asterisks"> *</span>
            }
          </span>
        </label>
      </div>
    )
  }
}
